const config = {
    mini_sidebar: false,
    actTheme: 'light',
    fontTheme: 'Roboto sans',
  };
  
  export default config;
  